<footer>
  <div class="footer-container">
    <p class="terms-conditions">© {{ currentYear }} Fundación Jala</p>
    <div class="social-media">
      <a href="{{ linkedinUrl }}" target="_blank">
        <img class="linkedin" src="../../assets/icons/linkedin-icon.svg"/>
      </a>
      <a href="{{ facebookUrl }}" target="_blank">
        <img class="facebook" src="../../assets/icons/facebook-icon.svg"/>
      </a>
      <a href="{{ instagramUrl }}" target="_blank">
        <img class="instagram" src="../../assets/icons/instagram-icon.svg"/>
      </a>
    </div>
  </div>
</footer>
